import styled from 'styled-components';

// Declarados antes do container, que os referencia como seletor. Sem `var()`:
// `hostCssVariables.spec.ts` só permite o namespace `--ticto-*`.

// Neutraliza o pill do `span {}` do container — senão vira pill aninhado.
export const CopyTarget = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 0.35rem;
	padding: 0;
	margin: 0;
	background: transparent;
	border-radius: 0;
	color: inherit;
	font: inherit;
`;

// Espaço fixo, só a opacidade alterna — a altura da linha não muda no hover.
export const CopyIcon = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 1em;
	width: 1em;
	height: 1em;
	padding: 0;
	margin: 0;
	background: transparent;
	border-radius: 0;
	line-height: 1;
	opacity: 0;
	transition: opacity 0.15s ease;

	svg {
		display: block;
		width: 1em;
		height: 1em;
	}
`;

export const TransactionDetailsContainer = styled.div`
	background: #edf2f7;
	border-radius: 0.5rem;
	padding: 1rem;
	gap: 0.7rem;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	font-size: 0.9rem;
	color: #000000 !important;

	p {
		margin: 0;
		color: #000000 !important;
	}

	span {
		padding: 0.2rem 0.5rem;
		background: #fff;
		border-radius: 0.5rem;
		margin-left: 0.5rem;
		color: #000000 !important;
	}

	span[data-tooltip-id] {
		cursor: pointer;

		&:hover ${CopyIcon}, &:focus-visible ${CopyIcon} {
			opacity: 1;
		}
	}

	@media (hover: none) {
		span[data-tooltip-id] ${CopyIcon} {
			opacity: 1;
		}
	}
`;
